module.exports = __webpack_public_path__ + "static/img/ActPoster_zgshfp_grey.582e432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active1017/ActPoster_zgshfp_grey.png
// module id = cpP1
// module chunks = 0